import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xxl-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white" }, "Doanh thu", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "card-p mt-n20 position-relative" }
const _hoisted_6 = { class: "row m-0" }
const _hoisted_7 = { class: "col bg-light-primary px-6 py-8 rounded-2 me-7 mb-7" }
const _hoisted_8 = { class: "svg-icon svg-icon-3x svg-icon-primary d-flex align-items-center my-2" }
const _hoisted_9 = { class: "text-primary fw-bold fs-3 ms-2 text-nowrap" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bold fs-6" }, " Tổng số đồng hồ ", -1)
const _hoisted_11 = { class: "col bg-light-danger px-6 py-8 rounded-2 mb-7" }
const _hoisted_12 = { class: "svg-icon svg-icon-3x svg-icon-danger d-flex align-items-center my-2" }
const _hoisted_13 = { class: "text-danger fw-bold fs-3 ms-2 text-nowrap" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold" }, " Đồng hồ mới ", -1)
const _hoisted_15 = { class: "row m-0" }
const _hoisted_16 = { class: "col bg-light-success px-6 py-8 rounded-2 me-7" }
const _hoisted_17 = { class: "svg-icon svg-icon-3x svg-icon-success d-flex align-items-center my-2" }
const _hoisted_18 = { class: "text-success fw-bold fs-3 ms-2 text-nowrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("sup", null, " đ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bold fs-6 mt-2" }, " Doanh thu ", -1)
const _hoisted_21 = { class: "col bg-light-primary px-6 py-8 rounded-2" }
const _hoisted_22 = { class: "svg-icon svg-icon-3x svg-icon-primary d-flex align-items-center my-2" }
const _hoisted_23 = { class: "text-primary fw-bold fs-3 ms-2 text-nowrap" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createTextVNode(" m"),
  /*#__PURE__*/_createElementVNode("sup", null, "3")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bold fs-6 mt-2" }, " Tiêu thụ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"])
    }, _hoisted_3, 2),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_apexchart, {
        class: _normalizeClass([`bg-${_ctx.widgetColor}`, "mixed-widget-2-chart card-rounded-bottom"]),
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: "200",
        type: "area",
        ref: "chart"
      }, null, 8, ["class", "options", "series"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.handleNumber(_ctx.data.nTongDongHo)), 1)
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" }),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.handleNumber(_ctx.data.nTongDongHoMoi)), 1)
            ]),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin003.svg" }),
              _createElementVNode("span", _hoisted_18, [
                _createTextVNode(_toDisplayString(_ctx.handleNumber(_ctx.data.nTongDoanhThu)), 1),
                _hoisted_19
              ])
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/home/water-mixer.svg" }),
              _createElementVNode("span", _hoisted_23, [
                _createTextVNode(_toDisplayString(_ctx.handleNumber(_ctx.data.nTongTieuThu)), 1),
                _hoisted_24
              ])
            ]),
            _hoisted_25
          ])
        ])
      ])
    ])
  ]))
}